import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Hakkimizda from "../pages/hakkimizda/page";
import Projelerimiz from "../pages/projelerimiz/page";
import StratejikOrtaklarimiz from "../pages/stratejik-ortaklarimiz/page";
import KontrolPaneli from "../pages/kontrol-paneli/page";
import SiteInspector from "../pages/site-inspector/page";
import Inspektor from "../pages/inspektor/page";
import DevPanel from "../pages/dev-panel/page";
import CustomPage from "../pages/custom-page/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/hakkimizda", element: <Hakkimizda /> },
  { path: "/projelerimiz", element: <Projelerimiz /> },
  { path: "/stratejik-ortaklarimiz", element: <StratejikOrtaklarimiz /> },
  { path: "/sayfa/:slug", element: <CustomPage /> },
  { path: "/kontrol-paneli", element: <KontrolPaneli /> },
  { path: "/site-inspector", element: <SiteInspector /> },
  { path: "/inspektor", element: <Inspektor /> },
  // Gizli gelistirici paneli — menulerde gozukmez, URL karmasik tutuldu
  { path: "/yapi/sistem/gelistirici-x9f2", element: <DevPanel /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
